import type { FlightFeatureConfig } from '../../../types/insurances/FlightFeatureConfig';

export const flight: FlightFeatureConfig = {
    overview: {
        details: {
            showVariant: true,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
};
